/**
 * @generated SignedSource<<9b4a19be20c128577cf72d830dca2b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTodoSummaryTodoDeletedSubscription$variables = {
  categoryIds: ReadonlyArray<string>;
  teamIds: ReadonlyArray<string>;
};
export type WidgetTodoSummaryTodoDeletedSubscription$data = {
  readonly todoDeleted: {
    readonly category: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly notResolvedCount: number;
      }>;
    } | null;
  } | null;
};
export type WidgetTodoSummaryTodoDeletedSubscription = {
  response: WidgetTodoSummaryTodoDeletedSubscription$data;
  variables: WidgetTodoSummaryTodoDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "categoryIds",
    "variableName": "categoryIds"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "ids",
          "variableName": "teamIds"
        }
      ],
      "concreteType": "TodoCategoryTeam",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notResolvedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTodoSummaryTodoDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTodoSummaryTodoDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fcbf65618d49d803128ecf0816b13d42",
    "id": null,
    "metadata": {},
    "name": "WidgetTodoSummaryTodoDeletedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetTodoSummaryTodoDeletedSubscription(\n  $teamIds: [ID!]!\n  $categoryIds: [ID!]!\n) {\n  todoDeleted(categoryIds: $categoryIds, teamIds: $teamIds) {\n    category {\n      id\n      teams(ids: $teamIds) {\n        id\n        notResolvedCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2f58b7cc5d737db4fa4f5255272d9d5";

export default node;
